import { useState } from 'react';
import { genUUIDV4 } from '@frontend/string';

export const usePaymentUuid = () => {
  const [paymentUuid, setPaymentUuid] = useState<string | undefined>(undefined);
  const generatePaymentUuid = () => {
    const newUuid = genUUIDV4();
    setPaymentUuid(newUuid);
    return newUuid;
  };

  return {
    paymentUuid,
    generatePaymentUuid,
  };
};
